import React from "react";
import ConductBoard from "@/components/app/ConductBoard";
import { Award } from "lucide-react";

export default function ConductPage() {
  return (
    <div className="space-y-5 max-w-5xl">
      <div>
        <span className="label-overline flex items-center gap-1.5"><Award className="w-3 h-3" /> Team</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-1">Recognition Board</h1>
        <p className="text-sm text-zinc-500 mt-2 max-w-2xl">
          Live view of warnings and appreciations across the team. Profiles are highlighted in red (hard warning), orange (soft warning), or green (appreciated).
        </p>
      </div>
      <ConductBoard />
    </div>
  );
}
